module.exports = __webpack_public_path__ + "static/media/employee_directory.644aa3e8.png";